import { useEffect, useState } from 'react';
import {
  fetchGroups,
  completeGroupManually,
  GroupMember,
} from '../../../services/groups';
import Tooltip from '@mui/material/Tooltip';
import { Group } from '../../../services/groups';
import CustomModal from '../../Global/CustomModal';

const GroupDashboard: React.FC = () => {
  const [groupList, setGroupList] = useState<Group[]>([]);
  const [showManualCompleteModal, setShowManualCompleteModal] = useState(false);
  const [showGroupMembersModal, setShowGroupMembersModal] = useState(false);
  const [groupMembers, setGroupMembers] = useState<GroupMember[]>([]);
  const [pendingManualCompleteGroupId, setPendingManualCompleteGroupId] =
    useState<string | null>(null);

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    const groups = await fetchGroups();
    if (groups) {
      setGroupList(groups);
    }
  };

  const handleManualComplete = async () => {
    if (pendingManualCompleteGroupId) {
      await completeGroupManually(pendingManualCompleteGroupId);
      setShowManualCompleteModal(false);
      loadGroups();
    }
  };

  const renderMemberEmails = (group: Group) => {
    return (
      <div>
        {group.members?.map((member) => (
          <div key={member.user.id}>{member.user.email}</div>
        ))}
      </div>
    );
  };

  return (
    <>
      <table className="users-list">
        <thead>
          <tr>
            <th>Status</th>
            <th>Created At</th>
            <th>Expires At</th>
            <th>Number of Members</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {groupList?.map((group: Group) => (
            <tr className="group-row" key={group.id}>
              <td>{group.status}</td>
              <td>{group.createdAt}</td>
              <td>{group.expiresAt}</td>
              <td>
                <Tooltip title={renderMemberEmails(group)} arrow>
                  <span>{group.members.length}</span>
                </Tooltip>
              </td>
              <td style={{ display: 'flex', gap: '.5rem' }}>
                {group.status === 'PENDING' && (
                  <button
                    onClick={() => {
                      setShowManualCompleteModal(true);
                      setPendingManualCompleteGroupId(group.id);
                    }}
                  >
                    Manually Complete
                  </button>
                )}
                <button
                  onClick={() => {
                    setShowGroupMembersModal(true);
                    setGroupMembers(group.members);
                  }}
                >
                  View Students
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showManualCompleteModal && (
        <CustomModal
          open={showManualCompleteModal}
          onClose={() => setShowManualCompleteModal(false)}
          name="manual-complete-group"
          glass={true}
        >
          <div className="modal">
            <div className="modal_header">
              <h2>Manually Complete Group?</h2>
            </div>
            <div className="modal_content">
              <p>Are you sure you want to manually complete this group?</p>
              <p>
                This will activate GROUP plan subscriptions for all members of
                the group.
              </p>
            </div>
            <div className="modal_footer">
              <button
                onClick={() => setShowManualCompleteModal(false)}
                className="button button--error"
              >
                Cancel
              </button>
              <button onClick={handleManualComplete}>Submit</button>
            </div>
          </div>
        </CustomModal>
      )}
      {showGroupMembersModal && (
        <CustomModal
          open={showGroupMembersModal}
          onClose={() => {
            setShowGroupMembersModal(false);
            setGroupMembers([]);
          }}
          name="group-members"
          glass={true}
        >
          <div className="modal">
            <div className="modal_header">
              <h2>Group Members</h2>
            </div>
            <div className="modal_content">
              {groupMembers?.map((member) => (
                <div key={member.user.id}>{member.user.email}</div>
              ))}
            </div>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default GroupDashboard;
